<template>
    <div>
        <div v-if="pending">
            <BaseSpinner />
        </div>
        <template v-else-if="!entry" /> <!-- empty case for when there is no entry, nuxt will show an error -->
        <article v-else>
            <HeroBasic
                :title="entry?.title"
                :description="entry?.textarea"
                :class="{ 'hero-basic--display': !entry?.parent }"
            >
                <template
                    v-if="entry?.parent"
                    #backlink
                >
                    <NuxtLink :to="localePath(`/${entry?.parent?.uri}`)"><div class="sr-only">{{ t('a11y.return-to') }} </div><BaseIcon icon="chevron-left" />{{ entry?.parent?.title }}</NuxtLink>
                </template>
            </HeroBasic>

            <FlexibleSections
                v-if="entry.flexibleSections"
                :sections="entry.flexibleSections"
            />
        </article>
    </div>
</template>

<script setup>
import { useMainStore } from '~/stores/main.js';
import { formatISO } from 'date-fns';
import getPage from '~/graphql/queries/getPage.graphql';

defineI18nRoute({
    paths: {
        en: '/funding/fund/[subsidy]/[slug]',
    }
});

const { t } = useI18n();
const localePath = useLocalePath();

const route = useRoute();

const { variables: defaultVariables }  = useCraftGraphql();

const uri = computed(() => {
    const slug = route.params.slug;
    const subsidy = route.params.subsidy;

    switch (defaultVariables.site) {
    case 'en':
        return `funding/fund/${subsidy}/${slug}`;
    case 'nl':
    default:
        return `subsidies/subsidie/${subsidy}/${slug}`;
    }
});

const variables = computed(() => {
    const now = formatISO(Date.now(), { representation: 'date' });

    return {
        ...defaultVariables,
        uri: uri.value, // We don't need the URI for this query
        section: 'subsidies',
        slug: route.params.slug,
        now: ['or', `>= ${now}`, null]
    };
});

const response = await useAsyncQuery({
    query: getPage,
    variables
});

// using response.pending in template is not reactive???
const pending = computed(() => response?.pending.value);

const { craftEntry: entry } = useCraftPageEther(response);

const mainStore = useMainStore();
watchEffect(() => {
    mainStore.toggleNewsletterSubscribe(entry.value?.showNewsletterSubscribe ?? false);
});
</script>
